import api from "./api";

export interface ColunaKanban {
  id: string;
  chave: string;
  label: string;
  cor: string;
  emoji: string;
  ordem: number;
  ehFinal: boolean;
  ehAprovacao: boolean;
  ativo: boolean;
}

export async function listarColunasKanban(opts?: { todos?: boolean }) {
  const r = await api.get(`/colunas-kanban${opts?.todos ? "?todos=1" : ""}`);
  return r.data.data as ColunaKanban[];
}

export async function criarColunaKanban(dados: { label: string; cor?: string; emoji?: string; ordem?: number }) {
  const r = await api.post("/colunas-kanban", dados);
  return r.data.data as ColunaKanban;
}

export async function atualizarColunaKanban(
  id: string,
  dados: Partial<{ label: string; cor: string; emoji: string; ordem: number; ativo: boolean }>,
) {
  const r = await api.patch(`/colunas-kanban/${id}`, dados);
  return r.data.data as ColunaKanban;
}

export async function reordenarColunasKanban(ordens: Array<{ id: string; ordem: number }>) {
  const r = await api.put(`/colunas-kanban/ordens`, { ordens });
  return r.data.data as ColunaKanban[];
}

export async function excluirColunaKanban(id: string) {
  await api.delete(`/colunas-kanban/${id}`);
}
